import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as NotifyActions from 'app/store/common-effects/notifier.effects';
import * as ProjectRouterActions from 'app/store/common-effects/router.effects';
import { CourierService } from 'core/http/dev';
import { LoaderService } from 'core/services/loader.service';
import { of } from 'rxjs';
import { catchError, exhaustMap, switchMap, tap } from 'rxjs/operators';
import * as CouriersActions from './couriers.actions';

@Injectable()
export class CouriersEffects {
  getCouriers$ = createEffect(() => this.actions$.pipe(
    ofType(CouriersActions.getDevCouriers),
    switchMap(() => this.courierService.getAllCouriers().pipe(
      switchMap(couriers => [
        CouriersActions.saveCouriers({ couriers }),
        CouriersActions.getClasses(),
      ]),
      catchError(response => of(
        CouriersActions.setError({ value: response }),
        NotifyActions.errorHttpNotify({ response }),
      )),
    )),
  ));

  createCourier$ = createEffect(() => this.actions$.pipe(
    ofType(CouriersActions.createCourier),
    tap(() => this.loader.begin()),
    exhaustMap(({ input }) => this.courierService.createCourier(input)),
    tap(() => this.loader.end()),
    switchMap(courier => [
      CouriersActions.addCourierInStore({ courier }),
      NotifyActions.notify({ message: 'NOTIFICATIONS.courier_created' }),
      ProjectRouterActions.navigateToDev({ path: ['couriers'] }),
    ]),
  ));

  updateCourier$ = createEffect(() => this.actions$.pipe(
    ofType(CouriersActions.updateCourier),
    tap(() => this.loader.begin()),
    exhaustMap(({ id, input }) => this.courierService.updateCourier(id, input)),
    tap(() => this.loader.end()),
    switchMap(courier => [
      CouriersActions.updateCourierInStore({ update: { id: courier.id, changes: courier } }),
      NotifyActions.notify({ message: 'NOTIFICATIONS.courier_updated' }),
      ProjectRouterActions.navigateToDev({ path: ['couriers'] }),
    ]),
  ));

  getClasses$ = createEffect(() => this.actions$.pipe(
    ofType(CouriersActions.getClasses),
    switchMap(() => this.courierService.getIntegrationClasses().pipe(
      switchMap(integrationClasses => [
        CouriersActions.saveClasses({ integrationClasses }),
        CouriersActions.markCouriersLoaded(),
      ]),
      catchError(response => of(
        CouriersActions.setError({ value: response }),
        NotifyActions.errorHttpNotify({ response }),
      )),
    )),
  ));

  constructor(
    private actions$: Actions,
    private courierService: CourierService,
    private loader: LoaderService,
  ) { }
}
